import { createBrowserRouter } from "react-router-dom";
import React from "react";

import FrontendLayout from "./pages/frontend/FrontendLayout";
import Page404 from "./pages/Page404";
import Redirect from "pages/components/Redirect";
import Login from "pages/frontend/components/auth-pages/Login";
import { getRoute } from "routes_management/routeManagement";
import { generateRoutes } from "routes_management/generateRoutes";
import PrivacyPolicy from "pages/frontend/PrivacyPolicy";

export const getRouter = (user) => {
    return createBrowserRouter([
        getRoute({ path: '/', element: <Redirect to='/login' passCurrentRoute={true} /> }),
        getRoute({path: '/privacy-policy', element: <FrontendLayout children={<PrivacyPolicy />} bypassAuthCheck={true} /> }),
        getRoute({ path: '/login', element: <FrontendLayout children={<Login />} /> }),
        {
            path: '/portal',
            children: user.id !== '' ? (
                [
                    ...generateRoutes(user),
                    getRoute({ path: '*', element: <FrontendLayout children={<Page404 className='bg-white container-fluid mt-2' />} /> }),
                ]
            ) : [
                getRoute({ path: '', element: <Redirect to='/login' passCurrentRoute={true} /> }),
                getRoute({ path: '*', element: <Redirect to='/login' passCurrentRoute={true} /> }),
            ]
        },
        getRoute({ path: '*', element: <FrontendLayout children={<Page404 />} bypassAuthCheck={true} /> }),
    ], {
        future: {
            v7_startTransition: true,
        },
    })
};
